export function isNeedToShowUserItemIcons({ isArchived, isHovered }) {
  return isArchived || isHovered
}
